import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from '../../../services/validator.service';
import { PointStoreProductOrderService } from 'src/app/gamification/marketplace/agent-side/services/point-store-product-order.service';
import { ToastrManager } from '@niceltd/sol/toastr';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { GridApi} from "ag-grid-community";

@Component({
  selector: 'cv-cxone-order-management-notes-modal',
  templateUrl: './cxone-order-management-notes-modal.component.html',
  styleUrl: './cxone-order-management-notes-modal.component.scss'
})
export class CxoneOrderManagementNotesModalComponent implements OnInit {
  formDataBinding: FormGroup = new FormGroup({});
  @Output() detectChangesForm: EventEmitter<any> = new EventEmitter();
  loading: boolean = false;
  headerTitle: string = this.dialogConfig.data.modalTitle;
  allowClose: boolean = true;
  modalPlaceholder: string = this.dialogConfig.data.modalPlaceholder;
  saveLabel:string = this.dialogConfig.data.modalSaveLabel;
  cancelLabel:string = this.dialogConfig.data.modalCancelLabel;
  noteValue: string = this.dialogConfig.data.noteData;
  pspos = null;
  orderData = null;
  gridApi:GridApi = null;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    public validatorService: ValidatorService,
    private pointStoreProductOrderService: PointStoreProductOrderService,
    private toastrManager: ToastrManager,
    private cvLocalizationFactory: CVLocalizationService,
  ) {
    this.pspos = pointStoreProductOrderService.pointStoreProductOrderObj;
  }

  ngOnInit(): void {
    this.cvLocalizationFactory.GetSection("Order_Management");
    this.initForm();
  }

  getLocalizationString(key: string, defaultValue: string): string {
    return this.cvLocalizationFactory.getCachedText("Order_Management", key, defaultValue);
  }

  initForm(): void {
    const formControlNotes = new FormControl([Validators.maxLength(200)]);
    this.formDataBinding.addControl('notes', formControlNotes);
    this.formDataBinding.controls['notes'].patchValue(this.dialogConfig.data.noteData);
    this.orderData = this.dialogConfig.data.order;
    this.gridApi = this.dialogConfig.data.gridApi;
  }

  async onSave() {
    try {
      this.pspos.originalPointStoreProductOrder = this.orderData;
      const rowData = [];
      this.gridApi.forEachNodeAfterFilterAndSort((rowNode, index) => {
        if (rowNode.data.PointStoreOrderID === this.orderData.PointStoreOrderID) {
          const data = rowNode.data;
          data.Note = this.noteValue;
          rowData.push(data);
        }
      });
      
      await this.pointStoreProductOrderService.EditPointStoreProductAdminOrderCxOne(rowData[0]);
      this.gridApi!.applyTransaction({ update: rowData })!;
      this.toastrManager.showToaster('success', this.getLocalizationString("Note_Saved_Successfully", "Note saved successfully."));
      this.onClose();
    } catch (e) {
      this.toastrManager.showToaster('error', this.getLocalizationString("Internal_Server_Error_Try_Again_Later", "Internal server error. Try again later."));
      console.error(e);
    }
  }

  onDismiss() {
    this.dialogRef.close();
  }

  onClose() {
    this.dialogRef.close();
  }
}
